import { render, staticRenderFns } from "./IpDomains.vue?vue&type=template&id=93c5d7ac&scoped=true&"
import script from "./IpDomains.vue?vue&type=script&lang=js&"
export * from "./IpDomains.vue?vue&type=script&lang=js&"
import style0 from "./IpDomains.vue?vue&type=style&index=0&id=93c5d7ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c5d7ac",
  null
  
)

export default component.exports